import React, {Component} from 'react'
import MediaManager from './form/types/media-helper/MediaManager.js'

class PageOpsMediaModal extends Component {

  constructor(props) {
    super(props);
  }

  handleInsertMedia(item){
    var imagePath;
    if (item.thumb) {
      imagePath = item.thumb
    } else {
      imagePath = item.path
    }
    jQuery('.sp-pagebuilder-media-preview').removeClass('sp-pagebuilder-media-no-image').attr('src',pagebuilder_base+imagePath);
    jQuery('#jform_og_image').val(imagePath);
    jQuery('.sp-pagebuilder-media-modal-overlay').hide();
  }

  handleMediaModal(){
    jQuery('.sp-pagebuilder-media-modal-overlay').hide();
  }

  render(){

    return(
      <MediaManager
        type="image"
        onHandleInsertMedia = { this.handleInsertMedia.bind(this) }
        onHandleMediaModal = { this.handleMediaModal.bind(this) }
      />
    )
  }
}

export default PageOpsMediaModal;



// WEBPACK FOOTER //
// ./src/helpers/PageOpsMediaModal.js